export interface PlayerCaptureInput {
  playerId: string
  nameFirst: string
  nameLast: string
  birthDate: string // 'YYYY-MM-DD'
  heightFt: string
  heightIn: string
  weight: string
  relationship: string // relationship_type id as string; '' when none
}

export interface PlayerAcceptPayload {
  id: string
  name_first: string
  name_last: string
  birth_date: string
  height: number | null
  weight: number | null
  relationship_type_id?: number
}

// ft+in → meters, mirroring the existing UnderageInvitation conversion
// (Number(`${ft}.${in}`) / 3.281). Returns null when no feet were entered.
const toMeters = (ft: string, inches: string): number | null => {
  if (!ft) {
    return null
  }
  return Number(`${ft}.${inches || 0}`) / 3.281
}

export const buildPlayerPayload = (
  input: PlayerCaptureInput
): PlayerAcceptPayload => {
  const payload: PlayerAcceptPayload = {
    id: input.playerId,
    name_first: input.nameFirst,
    name_last: input.nameLast,
    birth_date: input.birthDate,
    height: toMeters(input.heightFt, input.heightIn),
    weight: input.weight ? Number(input.weight) : null,
  }
  if (input.relationship) {
    payload.relationship_type_id = Number(input.relationship)
  }
  return payload
}
